import React, { useContext, useEffect, useRef, useState } from "react";
import EquipmentButtonIcons from "../../../constants/EquipmentButtonIcon";
import "./Key.css";
import { Context } from "../../../context/Context";

const ScenarioKey = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  scenarioType,
  commands,
  setCommands,
}) => {
  const {
    addScenarioCommandDetail,
    scenarioCommandDetail,
    scenarioCommands,
    setScenarioCommands,
    equipmentButtons,
    devices,
  } = useContext(Context);
  const [buttons, setButtons] = useState([]);
  const [selectedButton, setSelectedButton] = useState(null);

  useEffect(() => {
    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const getBits = (highByte, lowByte) => {
    const value = ((highByte & 0xff) << 8) | (lowByte & 0xff);
    const bits = [];

    for (let i = 0; i < 16; i++) {
      bits.push((value >> i) & 1);
    }

    return bits;
  };

  const handleClickButton = (button, icon) => {
    const statusBits = getBits(button.data1, button.data2);
    const selectionBits = getBits(button.data3, button.data4);

    const newCommands = [];

    selectionBits.forEach((bit, index) => {
      if (bit === 1) {
        newCommands.push({
          id: new Date().getTime() + newCommands.length + 1,
          scenario_id: addScenarioCommandDetail.scenario_id,
          device_id: button.device_id,
          time: scenarioCommandDetail.time ?? scenarioType ? 0 : 500,
          data1: index + 1,
          data2: statusBits[index],
          data3: null,
          data4: null,
          data5: null,
          data6: null,
          data7: null,
          data8: null,
          data9: null,
          data10: null,
          data11: null,
          command_name: `${button.name} ${index + 1}`,
          icon: icon,
        });
      }
    });

    if (scenarioCommandDetail.id) {
      setCommands((prev) =>
        prev
          .filter((cmd) => cmd.id !== scenarioCommandDetail.id)
          .concat(newCommands)
      );
    } else {
      setCommands((prev) => [...prev, ...newCommands]);
    }

    closeSelectEquipmentRef.current.click();
    closeSelectOutputEquipmentRef.current.click();
  };

  const renderButtons = () => {
    return buttons.map((button) => {
      let iconPath = "/assets/img/app-icons/dN.png";
      let iconId = 22;
      let device = devices.find((dev) => dev.id == button.device_id);
      if (!device) {
        return;
      }
      if (button.icon) {
              let buttonIcon = EquipmentButtonIcons.find(
                (icon) => icon.id == button.icon
              );
              iconPath = buttonIcon.path;
              iconId = buttonIcon.id;
            }
      return (
        <div className="key" onClick={() => handleClickButton(button, iconId)}>
          <div className="icon-part">
            <img src={iconPath} alt="" />
          </div>
          <div
            className={
              selectedButton && selectedButton.id == button.id
                ? "status-part bg-success"
                : "status-part"
            }
          ></div>
          <div className="info-part">
            <p className="text-center p-0 m-0 d-block">{button.name}</p>
            <p className="text-center p-0 m-0" style={{ fontSize: "11px" }}>
              S/{device.serial}
            </p>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
        style={{ zIndex: 1, top: "0" }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
      </div>
      <div className="card-body scrollbar">
        <div className="d-flex flex-wrap justify-content-between justify-content-sm-start">{renderButtons()}</div>
      </div>
    </div>
  );
};

export default React.memo(ScenarioKey);
